import MetricBox from "components-for/display/metric-box";
import { faList } from "@fortawesome/pro-duotone-svg-icons";
import { FunctionComponent, memo } from "react";
import { IProps } from "./agent-interactions-count-metric.types";
import { parseUrlArray } from "@edgetier/utilities";
import { useInteractionQueryParameters } from "hooks-for/filters/use-interaction-query-parameters";
import { useInteractionsCount } from "hooks-for/interactions/use-interactions-counts";
import { useQueryParameters } from "@edgetier/client-components";
import "./agent-interactions-count-metric.scss";

/**
 * Simple metric showing the number of interactions handled by the agent.
 * @param props.defaultEndDateTime   Closing date in range to search.
 * @param props.defaultStartDateTime Opening date in range to search.
 * @returns                          Interactions count metric.
 */
const AgentInteractionsCountMetric: FunctionComponent<IProps> = ({ defaultEndDateTime, defaultStartDateTime }) => {
    const filters = useInteractionQueryParameters({
        defaults: { startDateTime: defaultStartDateTime, endDateTime: defaultEndDateTime },
    });

    const { reviewAgentId } = useQueryParameters({ reviewAgentId: parseUrlArray });

    // Make sure to only send the review agent in the request.
    const agentParameters = { ...filters, agentId: reviewAgentId };
    const { data: agentCount, isLoading: isAgentInteractionsCountLoading } = useInteractionsCount(agentParameters);

    return (
        <MetricBox
            icon={faList}
            isLoading={isAgentInteractionsCountLoading}
            title="Interactions"
            tooltipContent="Total number of chats, calls, emails handled"
            value={agentCount ?? null}
        />
    );
};

export default memo(AgentInteractionsCountMetric);
